import { render, staticRenderFns } from "./app-information.vue?vue&type=template&id=3ab676cc&scoped=true&"
import script from "./app-information.vue?vue&type=script&lang=ts&"
export * from "./app-information.vue?vue&type=script&lang=ts&"
import style0 from "./app-information.vue?vue&type=style&index=0&id=3ab676cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab676cc",
  null
  
)

export default component.exports